import {
  Approval_Status,
  ApprovalAction,
  ApprovalAssignment_Read,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { Nullable } from '~types/Nullable';

export class ApprovalStatus {
  constructor(
    private _id: string,
    private biller_approved: boolean,
    private company_admin_approved: boolean,
    private foreman_approved: boolean,
    private driver_approved: boolean,
    private billing_approved_at: Nullable<Dayjs>,
    private field_approved_at: Nullable<Dayjs>,
  ) {}

  public get id(): string {
    return this._id;
  }

  public get billerApproved(): boolean {
    return this.biller_approved;
  }

  public get companyAdminApproved(): boolean {
    return this.company_admin_approved;
  }

  public get foremanApproved(): boolean {
    return this.foreman_approved;
  }

  public get driverApproved(): boolean {
    return this.driver_approved;
  }

  public get billingApprovedAt(): Nullable<Dayjs> {
    return this.billing_approved_at;
  }

  public get fieldApprovedAt(): Nullable<Dayjs> {
    return this.field_approved_at;
  }

  public get isApproved() {
    return (
      this.billerApproved ||
      this.companyAdminApproved ||
      this.foremanApproved ||
      this.driverApproved
    );
  }

  public static parse(proto: Approval_Status): ApprovalStatus {
    return new ApprovalStatus(
      proto.id ?? '',
      proto.biller_approved ?? false,
      proto.company_admin_approved ?? false,
      proto.foreman_approved ?? false,
      proto.driver_approved ?? false,
      proto.billing_approved_at ? dayjs(proto.billing_approved_at) : null,
      proto.field_approved_at ? dayjs(proto.field_approved_at) : null,
    );
  }
}

export class ApprovalAssignment {
  constructor(
    private _id: string,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
    private _approval_type:
      | 'biller'
      | 'company_admin'
      | 'driver'
      | 'foreman'
      | 'platform_admin'
      | null,
    private _approver_id: string | null,
    private _external_approver_name: string | null,
    private _approver_type: 'User' | 'Company' | 'Impersonation' | 'M2MClient' | null,
    private _approval_action: ApprovalAction | null,
  ) {}

  public get id() {
    return this._id;
  }

  public get createdAt() {
    return this._created_at;
  }

  public get updatedAt() {
    return this._updated_at;
  }

  public get approvalType() {
    return this._approval_type;
  }

  public get approverId() {
    return this._approver_id;
  }

  public get externalApproverName() {
    return this._external_approver_name;
  }

  public get approverType() {
    return this._approver_type;
  }

  public get approvalAction() {
    return this._approval_action;
  }

  public static parse(proto: ApprovalAssignment_Read) {
    return new ApprovalAssignment(
      proto.id,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.approval_type ?? null,
      proto.approver_id ?? null,
      proto.external_approver_name ?? null,
      proto.approver_type ?? null,
      proto.approval_action ?? null,
    );
  }
}
